import React, { useState, useEffect } from "react";
import { formatToBRL } from "brazilian-values";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { BiMoneyWithdraw } from "react-icons/bi";
import { IoDocumentLockOutline } from "react-icons/io5";
import { FaPix } from "react-icons/fa6";
import { TbProgressAlert } from "react-icons/tb";

import {
  AiOutlineTags,
  AiOutlineTeam,
  AiOutlineDollar,
  AiOutlineTool,
  AiOutlineLogout,
  AiOutlineDown
} from "react-icons/ai";
import { CiSettings } from "react-icons/ci";
import { IoKeyOutline } from "react-icons/io5";
import { TbReceiptTax } from "react-icons/tb";

import { RxDashboard } from "react-icons/rx";
import LogoImage from "../../assets/logo/logo-03.png";
import linhaimg from "../../assets/linha/linem.png";
import { fetchSaldo } from "../../integration/saldo/fetchSaldo";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [configOpen, setConfigOpen] = useState(false);
  const [financeOpen, setFinanceOpen] = useState(false);

  const [saldo, setSaldo] = useState(0);
  const [highlightSaldo, setHighlightSaldo] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const currentPath = window.location.pathname;

  useEffect(() => {
    funcSaldo();
  }, []);

  async function funcSaldo() {
    try {
      const resp = await fetchSaldo();
      setSaldo(resp.balance);
      setErrorMessage("");

      // Ativar efeito visual
      setHighlightSaldo(true);
      setTimeout(() => setHighlightSaldo(false), 1000); // 1 segundo
    } catch (erro) {
      setErrorMessage(erro);
    }
  }

  return (
    <aside className="text-gray-300 w-full md:w-64 flex-shrink-0">
      <div className="flex items-center justify-between h-16 my-4 px-4">
        <img src={LogoImage} alt="Logo" className="h-32 w-auto mx-auto mt-14" />
      </div>

      <nav className={`py-4 ${isOpen ? "block" : "hidden md:block"}`}>
        <div className="flex flex-nowrap mt-10 justify-center w-full overflow-hidden">
          {[...Array(20)].map((_, index) => (
            <img
              key={index}
              src={linhaimg}
              alt="Linha"
              className="w-28 h-auto opacity-40"
            />
          ))}
        </div>

        <div className="text-center text-slate-400 mt-1 text-[13px] w-full flex flex-col items-center">
          <div className="p-2 w-full text-center items-center">
            <div className="flex items-center mt-1">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse mr-2"></div>
              <p className="font-light mr-1">Saldo:</p>
              <p
                className={`text-[13px] font-semibold tracking-wider transition-all duration-700 ease-in-out transform
    ${
      highlightSaldo
        ? "bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0] text-green-800 scale-105 shadow-sm px-3 py-1 rounded-lg"
        : "hover:bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0] text-green-500"
    }`}
              >
                {formatToBRL(saldo / 100)}
              </p>
            </div>
          </div>

          {/* Botão de Atualizar Saldo */}
          <button
            onClick={funcSaldo}
            className="mt-2 px-4 py-1 w-full text-[13px] bg-[#e6e1db] text-slate-500"
          >
            Atualizar Saldo
          </button>
        </div>

        <div className="flex flex-nowrap mt-1 justify-center w-full overflow-hidden">
          {[...Array(20)].map((_, index) => (
            <img
              key={index}
              src={linhaimg}
              alt="Linha"
              className="w-28 h-auto opacity-40"
            />
          ))}
        </div>

        <ul className="space-y-2 p-5 items-center">
          {/* Dashboard */}
          <li
            className={`flex rounded-lg items-center ${
              currentPath === "/dashboard"
                ? "bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                : "hover:bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
            }`}
          >
            <RxDashboard className="ml-5 text-[#baa78e]" size={20} />
            <a
              href="/dashboard"
              className={`block text-[15px] font-light py-2 px-4 ${
                currentPath === "/dashboard" ? "text-[#000]" : "text-slate-600"
              }`}
            >
              Dashboard
            </a>
          </li>

          <hr className="border-t border-gray-200 my-4" />

          {/* Vendas */}
          <li
            className={`flex rounded-lg items-center ${
              currentPath === "/sales"
                ? "bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                : "hover:bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
            }`}
          >
            <AiOutlineTags className="ml-5 text-[#baa78e]" size={20} />
            <a
              href="/sales"
              className={`block text-[15px] font-light py-2 px-4 ${
                currentPath === "/sales" ? "text-[#000]" : "text-slate-600"
              }`}
            >
              Vendas
            </a>
          </li>

          <hr className="border-t border-gray-200 my-4" />

          {/* Clientes */}
          <li
            className={`flex rounded-lg items-center ${
              currentPath === "/client"
                ? "bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                : "hover:bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
            }`}
          >
            <AiOutlineTeam className="ml-5 text-[#baa78e]" size={20} />
            <a
              href="/client"
              className={`block text-[15px] font-light py-2 px-4 ${
                currentPath === "/client" ? "text-[#000]" : "text-slate-600"
              }`}
            >
              Clientes
            </a>
          </li>

          <hr className="border-t border-gray-200 my-4" />

          {/* Financeiro com submenu */}
          <li className="flex flex-col">
            <div
              className={`flex items-center justify-between rounded-lg cursor-pointer transition-colors duration-200
      ${
        financeOpen || currentPath.startsWith("/finance")
          ? "bg-[#f4f1ec]"
          : "hover:bg-[#f4f1ec]"
      }`}
              onClick={() => setFinanceOpen(!financeOpen)}
            >
              <div className="flex items-center">
                <AiOutlineDollar className="ml-5 text-[#baa78e]" size={20} />
                <span
                  className={`block text-[15px] font-light py-2 px-4 transition-colors duration-200 ${
                    currentPath.startsWith("/finance")
                      ? "text-[#000]"
                      : "text-slate-600"
                  }`}
                >
                  Financeiro
                </span>
              </div>
              <AiOutlineDown
                className={`mr-4 text-[#baa78e] transition-transform duration-200 ${
                  financeOpen ? "rotate-180" : ""
                }`}
                size={16}
              />
            </div>

            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                financeOpen || currentPath.startsWith("/finance")
                  ? "max-h-[500px]"
                  : "max-h-0"
              }`}
            >
              <ul className="ml-7 mt-2 border-l-2 border-[#baa78e] pl-4 space-y-2">
                <li>
                  <a
                    href="/finance/balancehistory"
                    className={`text-sm flex items-center gap-2 py-1 pr-4 rounded-md transition-colors duration-150 ${
                      currentPath === "/finance/balancehistory"
                        ? "text-[#000] font-medium bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                        : "text-slate-600 hover:text-[#000] hover:bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                    }`}
                  >
                    <MdOutlineAccountBalanceWallet size={16} /> Saldo
                  </a>
                </li>
                <li>
                  <a
                    href="/finance/infractions"
                    className={`text-sm flex items-center gap-2 py-1 pr-4 rounded-md transition-colors duration-150 ${
                      currentPath === "/finance/infractions"
                        ? "text-[#000] font-medium bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                        : "text-slate-600 hover:text-[#000] hover:bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                    }`}
                  >
                    <TbProgressAlert size={16} /> Infrações
                  </a>
                </li>
                <li>
                  <a
                    href="/finance/withdraw"
                    className={`text-sm flex items-center gap-2 py-1 pr-4 rounded-md transition-colors duration-150 ${
                      currentPath === "/finance/withdraw"
                        ? "text-[#000] font-medium bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                        : "text-slate-600 hover:text-[#000] hover:bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                    }`}
                  >
                    <BiMoneyWithdraw size={16} /> Saques
                  </a>
                </li>
                <li>
                  <a
                    href="/finance/keypix"
                    className={`text-sm flex items-center gap-2 py-1 pr-4 rounded-md transition-colors duration-150 ${
                      currentPath === "/finance/keypix"
                        ? "text-[#000] font-medium bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                        : "text-slate-600 hover:text-[#000] hover:bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                    }`}
                  >
                    <FaPix size={16} /> Chave Pix
                  </a>
                </li>
              </ul>
            </div>
          </li>

          <hr className="border-t border-gray-200 my-4" />

          {/* Configurações com submenu */}
          <li className="flex flex-col">
            <div
              className={`flex items-center justify-between rounded-lg cursor-pointer transition-colors duration-200
    ${
      configOpen || currentPath.startsWith("/config")
        ? "bg-[#f4f1ec]"
        : "hover:bg-[#f4f1ec]"
    }`}
              onClick={() => {
                setConfigOpen(!configOpen);
              }}
            >
              <div className="flex items-center">
                <AiOutlineTool className="ml-5 text-[#baa78e]" size={20} />
                <span
                  className={`block text-[15px] font-light py-2 px-4 transition-colors duration-200 ${
                    currentPath.startsWith("/config")
                      ? "text-[#000]"
                      : "text-slate-600"
                  }`}
                >
                  Configurações
                </span>
              </div>
              <AiOutlineDown
                className={`mr-4 text-[#baa78e] transition-transform duration-200 ${
                  configOpen ? "rotate-180" : ""
                }`}
                size={16}
              />
            </div>

            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                configOpen || currentPath.startsWith("/config")
                  ? "max-h-[500px]"
                  : "max-h-0"
              }`}
            >
              <ul className="ml-7 mt-2 border-l-2 border-[#baa78e] pl-4 space-y-2">
                <li>
                  <a
                    href="/config/general"
                    className={`text-sm flex items-center gap-2 py-1 pr-4 rounded-md transition-colors duration-150 ${
                      currentPath === "/config/general"
                        ? "text-[#000] font-medium bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                        : "text-slate-600 hover:text-[#000] hover:bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                    }`}
                  >
                    <CiSettings size={16} /> Ajustes Gerais
                  </a>
                </li>
                <li>
                  <a
                    href="/config/api"
                    className={`text-sm flex items-center gap-2 py-1 pr-4 rounded-md transition-colors duration-150 ${
                      currentPath === "/config/api"
                        ? "text-[#000] font-medium bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                        : "text-slate-600 hover:text-[#000] hover:bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                    }`}
                  >
                    <IoKeyOutline size={16} /> Credenciais de API
                  </a>
                </li>
                <li>
                  <a
                    href="/config/tax"
                    className={`text-sm flex items-center gap-2 py-1 pr-4 rounded-md transition-colors duration-150 ${
                      currentPath === "/config/tax"
                        ? "text-[#000] font-medium bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                        : "text-slate-600 hover:text-[#000] hover:bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0]"
                    }`}
                  >
                    <TbReceiptTax size={16} /> Taxas
                  </a>
                </li>
              </ul>
            </div>
          </li>

          <hr className="border-t border-gray-200 my-4" />

          <li
            className="flex rounded-lg items-center hover:bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0] cursor-pointer"
            onClick={() => {
              window.open(
                "https://medusa-payments.readme.io/reference/introdu%C3%A7%C3%A3o",
                "_blank",
                "noopener,noreferrer"
              );
            }}
          >
            <IoDocumentLockOutline className="ml-5 text-[#baa78e]" size={20} />
            <span className="block text-[15px] font-light py-2 px-4 text-slate-600">
              Documentação
            </span>
          </li>

          <hr className="border-t border-gray-200 my-4" />

          {/* Sair */}
          <li
            className="flex rounded-lg items-center hover:bg-gradient-to-r from-[#fcfcfd] to-[#e9dfd0] cursor-pointer"
            onClick={() => {
              localStorage.clear();
              sessionStorage.clear();
              window.location.href = "/";
            }}
          >
            <AiOutlineLogout className="ml-5 text-[#baa78e]" size={20} />
            <span className="block text-[15px] font-light py-2 px-4 text-slate-600">
              Sair
            </span>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
